export default __webpack_public_path__ + "static/media/chevron-left-outline-24px.0527cfdb.svg";